import Head from 'next/head';
import styles from './Legal.module.css';

export default function PrivacyPolicy() {
  return (
    <>
      <Head>
        <title>Privacy Policy | ShuffleDB</title>
        <meta
          name="description"
          content="Privacy Policy for ShuffleDB and PostDat Publisher."
        />
      </Head>
      <main className={styles.page}>
        <article className={styles.document}>
          <h1>Privacy Policy</h1>
          <p className={styles.updated}>Effective August 7, 2026</p>

          <p>
            This Privacy Policy explains how ShuffleDB (“ShuffleDB,” “we,” “us,” or
            “our”) handles information when you use shuffledb.com, PostDat Publisher,
            and our related services (collectively, the “Services”).
          </p>

          <h2>Information we collect</h2>
          <ul>
            <li>Account details, such as your name, email address, and profile image.</li>
            <li>
              Content and publishing details you provide, including media, captions,
              schedules, drafts, and publishing history.
            </li>
            <li>
              Information supplied by connected services such as TikTok, Instagram,
              Facebook, Google, and YouTube, including account identifiers, display
              names, permissions, access tokens, and publishing results.
            </li>
            <li>
              Technical and usage information, including browser data, IP address,
              device information, request logs, and service diagnostics.
            </li>
          </ul>

          <h2>How we use information</h2>
          <p>
            We use information to provide and secure the Services; authenticate users;
            connect accounts; prepare, schedule, and publish content at your direction;
            show publishing status and analytics; troubleshoot failures; prevent abuse;
            and comply with legal obligations. We do not sell personal information.
          </p>

          <h2>Connected platforms</h2>
          <p>
            When you connect a third-party platform, we request only the permissions
            needed for features you choose. Platform credentials are stored on the
            server and are not displayed back to the browser. You may disconnect a
            platform through PostDat or the platform’s own account settings. Your use
            of a connected platform also remains subject to that platform’s terms and
            privacy policy.
          </p>

          <h2>Sharing and service providers</h2>
          <p>
            We disclose information only as needed to operate the Services—for example,
            to hosting, database, authentication, storage, monitoring, and connected
            social-platform providers—or when required by law. Providers may process
            information only for the services they supply to us.
          </p>

          <h2>Retention and deletion</h2>
          <p>
            We retain information while it is needed to provide the Services, meet
            security and legal requirements, resolve disputes, and enforce agreements.
            You may request deletion of your account and associated personal data by
            emailing <a href="mailto:privacy@shuffledb.com">privacy@shuffledb.com</a>.
            Some records may be retained where legally required or necessary for fraud
            prevention and system integrity.
          </p>

          <h2>Security</h2>
          <p>
            We use reasonable administrative, technical, and organizational safeguards
            designed to protect information. No storage or transmission method can be
            guaranteed completely secure.
          </p>

          <h2>Your choices and rights</h2>
          <p>
            Depending on your location, you may have rights to access, correct, delete,
            restrict, or export personal information, or object to certain processing.
            Contact us to exercise a request. You may also revoke a connected platform’s
            access from that platform at any time.
          </p>

          <h2>Children</h2>
          <p>
            The Services are not directed to children under 13, and we do not knowingly
            collect personal information from children under 13.
          </p>

          <h2>Changes to this policy</h2>
          <p>
            We may update this policy as the Services change. We will post the revised
            policy here and update its effective date.
          </p>

          <h2>Contact</h2>
          <p>
            Questions or privacy requests may be sent to{' '}
            <a href="mailto:privacy@shuffledb.com">privacy@shuffledb.com</a>.
          </p>
        </article>
      </main>
    </>
  );
}
